<div class="dashboard">
  <div class="dashboard-header">
    <h1>Tableau de bord</h1>
    <p>@if (isMagasin) {Gestion du magasin} @else {Vue d'ensemble de l'activité LaBase}</p>
  </div>

  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon">
        <i class="pi pi-shopping-cart"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Commandes du jour</div>
        <div class="stat-value">{{ stats.totalCommandes }}</div>
      </div>
    </div>

    <div class="stat-card stat-success">
      <div class="stat-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Commandes récupérées</div>
        <div class="stat-value">{{ stats.commandesRecuperees }}</div>
      </div>
    </div>

    <div class="stat-card stat-warning">
      <div class="stat-icon">
        <i class="pi pi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Commandes en attente</div>
        <div class="stat-value">{{ stats.commandesEnAttente }}</div>
      </div>
    </div>

    <div class="stat-card stat-info">
      <div class="stat-icon">
        <i class="pi pi-users"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Utilisateurs actifs</div>
        <div class="stat-value">{{ stats.activeUsers }}</div>
      </div>
    </div>
  </div>

  <div class="content-grid">
    <div class="section">
      <div class="section-header">
        <h2>Commandes du jour</h2>
        <button class="btn-refresh" (click)="loadCommandesDuJour()" title="Rafraîchir les commandes">
          <i class="pi pi-refresh"></i>
        </button>
      </div>

      <!-- Skeleton Loading pour les commandes -->
      @if (loadingCommandes) {
        <div class="skeleton-container">
          @for (i of [1, 2, 3]; track i) {
            <div class="skeleton-commande-card">
              <div class="skeleton-header">
                <div class="skeleton-line skeleton-line-short"></div>
                <div class="skeleton-badge"></div>
              </div>
              <div class="skeleton-content">
                <div class="skeleton-line skeleton-line-medium"></div>
                <div class="skeleton-line skeleton-line-long"></div>
              </div>
            </div>
          }
        </div>
      }

      @if (!loadingCommandes) {
        @if (commandesDuJour.length === 0) {
          <div class="empty-state">
            <i class="pi pi-inbox empty-icon"></i>
            <p>Aucune commande aujourd'hui</p>
          </div>
        }

        <!-- Groupes de commandes par statut (ordre logique) -->
        @for (statutId of [1, 2, 3, 4, 5]; track statutId) {
          @if (getStatutCount(statutId) > 0) {
            <div class="commandes-groupe">
              <!-- En-tête du groupe avec accordéon -->
              <div class="groupe-header" (click)="toggleAccordeon(statutId)">
                <div class="groupe-title">
                  <i class="pi" [class]="accordeonOuvert[statutId] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  <!-- Checkbox "Tout sélectionner" pour les commandes "En cours" -->
                  @if (isMagasin && statutId === 1) {
                    <input
                      type="checkbox"
                      [checked]="areAllEnCoursSelected()"
                      (click)="toggleSelectAllEnCours(); $event.stopPropagation()"
                      class="select-all-checkbox"
                      title="Tout sélectionner / Tout désélectionner"
                    />
                  }
                  <span class="statut-label" [class]="'status-' + statutId">
                    {{ getStatutLabel(statutId) }}
                  </span>
                  <span class="badge">{{ getStatutCount(statutId) }}</span>
                </div>
                @if (isMagasin && statutId === 1 && selectedCommandeIds.size > 0) {
                  <!-- Bouton "Valider et imprimer" pour les commandes sélectionnées -->
                  <button
                    class="btn-validate-print"
                    (click)="validerEtImprimerSelection(); $event.stopPropagation()"
                    [disabled]="isValidatingAndPrinting"
                    title="Valider et imprimer les commandes sélectionnées">
                    <i class="pi pi-print"></i>
                    Valider et imprimer ({{ selectedCommandeIds.size }})
                  </button>
                } @else if (isMagasin && peutPasserEtapeSuivante(statutId) && statutId !== 1) {
                  <button
                    class="btn-group-action btn-group-action-{{ getProchainStatut(statutId) }}"
                    (click)="passerToutesEtapeSuivante(statutId); $event.stopPropagation()"
                    title="Passer toutes les commandes à l'étape suivante">
                    <i class="pi pi-arrow-right"></i>
                    Tout passer à "{{ getStatutLabel(getProchainStatut(statutId)) }}"
                  </button>
                }
              </div>

              <!-- Contenu du groupe (accordéon) -->
              @if (accordeonOuvert[statutId]) {
                <div class="groupe-content">
                  @for (commande of commandesParStatut[statutId]; track commande.id) {
                    <div class="commande-card" [class.selected]="isCommandeSelected(commande.id!)">
                      <div class="commande-header">
                        <!-- Checkbox pour sélection individuelle (uniquement pour statut "En cours") -->
                        @if (isMagasin && statutId === 1) {
                          <input
                            type="checkbox"
                            [checked]="isCommandeSelected(commande.id!)"
                            (change)="toggleCommandeSelection(commande.id!)"
                            class="commande-checkbox"
                          />
                        }
                        <div
                          class="commande-num clickable-copy"
                          (click)="copyToClipboard(commande.NumCom, 'Numéro de commande', $event)"
                          title="Cliquer pour copier">
                          {{ commande.NumCom }}
                        </div>
                        @if (isMagasin) {
                          <div class="commande-actions">
                            <!-- Bouton d'action rapide selon le statut (masqué pour les commandes "En cours" car on utilise la sélection multiple) -->
                            @if (peutPasserEtapeSuivante(statutId) && statutId !== 1) {
                              <button
                                class="btn-action-rapide btn-action-rapide-{{ getProchainStatut(statutId) }}"
                                type="button"
                                (click)="passerEtapeSuivante(commande)"
                                title="{{ getActionButtonLabel(statutId) }}">
                                <i class="pi {{ getActionButtonIcon(statutId) }}"></i>
                                {{ getActionButtonLabel(statutId) }}
                              </button>
                            }
                            <!-- Select pour changer vers n'importe quel statut (super_admin uniquement) -->
                            @if (isSuperAdmin) {
                              <select
                                class="status-select"
                                [(ngModel)]="commande.statutOrdre"
                                (change)="onStatusChange(commande)"
                                title="Changer le statut manuellement">
                                <option [value]="1">En cours</option>
                                <option [value]="2">Validée</option>
                                <option [value]="3">Récupérée</option>
                                <option [value]="4">Non récupérée</option>
                                <option [value]="5">Annulée</option>
                              </select>
                            }
                            <!-- Bouton pour réimprimer le ticket -->
                            <button
                              class="btn-reprint-commande"
                              type="button"
                              (click)="reprintCommande(commande)"
                              title="Réimprimer le ticket">
                              <i class="pi pi-print"></i>
                            </button>
                            <!-- Bouton pour annuler la commande (petit et discret, à droite) -->
                            @if (statutId !== 5) {
                              <button
                                class="btn-cancel-commande"
                                type="button"
                                (click)="annulerCommande(commande)"
                                title="Annuler cette commande">
                                <i class="pi pi-times"></i>
                              </button>
                            }
                          </div>
                        } @else {
                          <div class="commande-status" [class]="'status-' + commande.statutOrdre">
                            {{ commande.statutNom }}
                          </div>
                        }
                      </div>
                      <div class="commande-info">
                        <div class="info-item">
                          <span class="label">Heure de récupération:</span>
                          <span class="value">{{ commande.heureRecuperation }}</span>
                        </div>
                        <div class="info-item">
                          <span class="label">Utilisateur:</span>
                          <span
                            class="value clickable-copy user-name"
                            (click)="copyToClipboard(commande.user_id, 'ID utilisateur', $event)"
                            [title]="'Cliquer pour copier l\'ID: ' + commande.user_id">
                            {{ commande.userName || 'Utilisateur inconnu' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      }
    </div>

    @if (isMagasin) {
      <div class="section">
        <div class="section-header">
          <h2>Produits à valider</h2>
          <div class="section-actions">
            <button class="btn-refresh" (click)="loadProduitsAValider()" title="Rafraîchir les produits à valider">
              <i class="pi pi-refresh"></i>
            </button>
            @if (miseadisposAuto.length > 0) {
              <button class="btn-validate-all" (click)="validateAll()">
                <i class="pi pi-check-circle"></i>
                Tout valider ({{ miseadisposAuto.length }})
              </button>
            }
          </div>
        </div>

        <div class="produits-auto-list">
          <!-- Skeleton Loading pour produits à valider -->
          @if (loadingProduitsAValider) {
            @for (i of [1, 2, 3]; track i) {
              <div class="skeleton-produit-card">
                <div class="skeleton-produit-image"></div>
                <div class="skeleton-produit-info">
                  <div class="skeleton-line skeleton-line-medium"></div>
                  <div class="skeleton-line skeleton-line-short"></div>
                  <div class="skeleton-line skeleton-line-short"></div>
                </div>
                <div class="skeleton-produit-actions">
                  <div class="skeleton-button"></div>
                  <div class="skeleton-button"></div>
                </div>
              </div>
            }
          }

          @if (!loadingProduitsAValider && miseadisposAuto.length === 0) {
            <div class="empty-state">
              <i class="pi pi-box empty-icon"></i>
              <p>Aucun produit en attente de validation</p>
            </div>
          }

          @if (!loadingProduitsAValider) {
            @for (produit of miseadisposAuto; track produit.id) {
            <div class="produit-auto-card">
              @if (produit.produit?.img || produit.imageProduit) {
                <img [src]="produit.produit?.img || produit.imageProduit" [alt]="produit.libelle" class="produit-image" />
              } @else {
                <div class="produit-image-placeholder">
                  <i class="pi pi-box"></i>
                </div>
              }
              <div class="produit-info">
                <div class="produit-title">{{ produit.libelle }}</div>
                @if (produit.description) {
                  <div class="produit-commercial">{{ produit.description }}</div>
                }
                <div class="produit-details">
                  <span
                    class="produit-plu clickable-copy"
                    (click)="copyToClipboard(produit.produitPlu.toString(), 'PLU', $event)"
                    title="Cliquer pour copier le PLU">
                    PLU: {{ produit.produitPlu }}
                  </span>
                  <div class="produit-qty-edit">
                    <label>Qté:</label>
                    <input
                      type="number"
                      [(ngModel)]="produit.quantiteActuel"
                      min="1"
                      class="qty-input"
                      (click)="$event.stopPropagation()"
                    />
                  </div>
                </div>
              </div>
              <div class="produit-actions-compact">
                <button
                  class="btn-validate-compact"
                  (click)="validateMiseadispo(produit)"
                  title="Valider et publier">
                  <i class="pi pi-check"></i>
                </button>
                <button
                  class="btn-delete-compact"
                  (click)="deleteMiseadispo(produit)"
                  title="Supprimer ce produit">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
            }
          }
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h2>Produits mis à disposition aujourd'hui</h2>
          <div class="section-actions">
            <button class="btn-refresh" (click)="loadProduitsDuJour()" title="Rafraîchir les produits du jour">
              <i class="pi pi-refresh"></i>
            </button>
            @if (miseadisposDuJour.length > 0) {
              <button
                class="btn-resend-notification"
                (click)="resendNotification()"
                [disabled]="isSendingNotification"
                title="Renvoyer la notification aux étudiants">
                <i class="pi" [class]="isSendingNotification ? 'pi-spin pi-spinner' : 'pi-bell'"></i>
                Renvoyer la notification
              </button>
            }
          </div>
        </div>

        <div class="produits-auto-list">
          <!-- Skeleton Loading pour produits du jour -->
          @if (loadingProduitsDuJour) {
            @for (i of [1, 2, 3]; track i) {
              <div class="skeleton-produit-card">
                <div class="skeleton-produit-image"></div>
                <div class="skeleton-produit-info">
                  <div class="skeleton-line skeleton-line-medium"></div>
                  <div class="skeleton-line skeleton-line-short"></div>
                  <div class="skeleton-line skeleton-line-short"></div>
                </div>
                <div class="skeleton-produit-actions">
                  <div class="skeleton-button"></div>
                </div>
              </div>
            }
          }

          @if (!loadingProduitsDuJour && miseadisposDuJour.length === 0) {
            <div class="empty-state">
              <i class="pi pi-eye-slash empty-icon"></i>
              <p>Aucun produit mis à disposition aujourd'hui</p>
            </div>
          }

          @if (!loadingProduitsDuJour) {
            @for (produit of miseadisposDuJour; track produit.id) {
            <div class="produit-auto-card produit-visible">
              @if (produit.produit?.img || produit.imageProduit) {
                <img [src]="produit.produit?.img || produit.imageProduit" [alt]="produit.libelle" class="produit-image" />
              } @else {
                <div class="produit-image-placeholder">
                  <i class="pi pi-box"></i>
                </div>
              }
              <div class="produit-info">
                <div class="produit-title">{{ produit.libelle }}</div>
                @if (produit.description) {
                  <div class="produit-commercial">{{ produit.description }}</div>
                }
                <div class="produit-details">
                  <span
                    class="produit-plu clickable-copy"
                    (click)="copyToClipboard(produit.produitPlu.toString(), 'PLU', $event)"
                    title="Cliquer pour copier le PLU">
                    PLU: {{ produit.produitPlu }}
                  </span>
                  <span class="produit-qty">Disponible: {{ produit.quantiteActuel }} / {{ produit.quantiteInit }}</span>
                </div>
              </div>
              <div class="produit-actions">
                <div class="badge-visible">
                  <i class="pi pi-eye"></i>
                  Visible
                </div>
                <button class="btn-cancel" (click)="cancelMiseadispo(produit)" title="Annuler cette mise à disposition">
                  <i class="pi pi-times"></i>
                  Annuler
                </button>
              </div>
            </div>
            }
          }
        </div>
      </div>

    }
  </div>
</div>


